// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__6upQB","actions":"GroupTable_actions__16jRV","deleteModalFooter":"GroupTable_deleteModalFooter__1PnXA"};